import React from 'react';
import Hero from './Hero';
import Details from './Details';
import Story from './Story';
import Gallery from './Gallery';
import Countdown from './Countdown';
import Footer from './Footer';

const Home = () => {
    return (
        <>
            <Hero />
            <Gallery />
            <Details />
            <Story />
            <Countdown />
            <Footer />
        </>
    );
};

export default Home;
